// Config is resolved at runtime from window.__RUNTIME_CONFIG__ (generated on
// container start from the admin-app-config configMap env vars), falling back to
// build-time import.meta.env for local development.
const BUILD_TIME_ENV: Record<string, string | undefined> = {
  VITE_AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
  VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  VITE_AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,
  VITE_API_DOMAIN: import.meta.env.VITE_API_DOMAIN,
};

function readEnv(name: string): string | undefined {
  const runtimeValue = window.__RUNTIME_CONFIG__?.[name];
  return runtimeValue !== undefined && runtimeValue !== '' ? runtimeValue : BUILD_TIME_ENV[name];
}

export function ensureExist(value: string | undefined, name: string): string {
  if (value === undefined || value === null || value === '') {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export const AUTH0_DOMAIN = ensureExist(readEnv('VITE_AUTH0_DOMAIN'), 'VITE_AUTH0_DOMAIN');
export const AUTH0_CLIENT_ID = ensureExist(readEnv('VITE_AUTH0_CLIENT_ID'), 'VITE_AUTH0_CLIENT_ID');
export const AUTH0_AUDIENCE = ensureExist(readEnv('VITE_AUTH0_AUDIENCE'), 'VITE_AUTH0_AUDIENCE');

export const API_DOMAIN = ensureExist(readEnv('VITE_API_DOMAIN'), 'VITE_API_DOMAIN');

export const ADMIN_ROLE = 'admin';

export const PAGE_SIZE = 50;

export const JOB_POLL_INTERVAL_MS = 5000;
